import React from 'react'

import ChecklistFiltersList from '../../../../containers/checklists/filters/ChecklistFiltersList'
import ScreenViewFilterBar from '../../../../containers/screenViews/ScreenViewFilterBar'

const FiltersBar = ({ open }) => {
  return (
    <ScreenViewFilterBar screen="checklists" open={open}>
      <ChecklistFiltersList />
    </ScreenViewFilterBar>
  )
}

export default FiltersBar
